<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("orders") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-6 col-5 text-right">
                    <!-- ปุ่ม "ซิงก์ Makro" ถูกถอดออกตามคำสั่ง (2026-08-21) — handleMiraklSync() ยังอยู่เผื่อเปิดคืน -->
                    <base-button
                        size="md"
                        type="neutral"
                        @click="handleCreate()"
                        >{{ $t("new") }}</base-button
                    >
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
						<!-- แท็บ "รายการสั่งซื้อ" / "กำลังตีกลับ" ถูกถอดออกตามคำสั่ง (2026-08-21)
						     activeTab ค้างที่ 'all' เสมอ ส่วนของแท็บ return ยังอยู่ในไฟล์เผื่อเปิดคืน -->

						<!-- Return-in-transit filters -->
						<div class="row" v-if="activeTab === 'return'">
							<div class="col-md-2 col-xs-12">
								<base-input>
									<flat-picker
										slot-scope="{ focus, blur }"
										@on-open="focus"
										@on-close="blur"
										:config="{ allowInput: true }"
										:placeholder="$t('time_from')"
										class="form-control datepicker"
										v-model="returnParams.time_from"
									>
									</flat-picker>
								</base-input>
							</div>
							<div class="col-md-2 col-xs-12">
								<base-input>
									<flat-picker
										slot-scope="{ focus, blur }"
										@on-open="focus"
										@on-close="blur"
										:config="{ allowInput: true }"
										:placeholder="$t('time_to')"
										class="form-control datepicker"
										v-model="returnParams.time_to"
									>
									</flat-picker>
								</base-input>
							</div>
							<div class="col-md-2">
								<base-input>
									<el-select
										v-model="returnParams.bo_platform_id"
										:placeholder="$t('platform')"
										filterable
									>
										<el-option
											v-for="option in PlatformTableWithAll"
											:key="option.id"
											:label="option.name"
											:value="option.id"
										>
										</el-option>
									</el-select>
								</base-input>
							</div>
							<div class="col-md-2">
								<base-input>
									<el-select
										v-model="returnParams.bo_sale_channel_id"
										:placeholder="$t('sale_channel')"
										filterable
									>
										<el-option
											v-for="option in SaleChannelTableWithAll"
											:key="option.id"
											:label="option.name"
											:value="option.id"
										>
										</el-option>
									</el-select>
								</base-input>
							</div>
							<div class="col-md-2">
								<base-input>
									<el-select
										v-model="returnParams.return_source"
										:placeholder="$t('return_source')"
										filterable
										clearable
									>
										<el-option
											v-for="option in ReturnSourceTable"
											:key="option.id"
											:label="option.name"
											:value="option.id"
										>
										</el-option>
									</el-select>
								</base-input>
							</div>
							<div class="col-auto">
								<base-button size="md" @click="handleSearchReturn()">
									<i class="fas fa-spinner fa-spin" v-if="isReturnInTransitLoading"></i>
									{{ $t("search") }}</base-button
								>
							</div>
						</div>

						<div class="row" v-else-if="params.bo_packing_id != ''">
							<div class="col-md-8">
								{{  $t('packing_number') }} : {{ params.bo_packing_id}}
							</div>
							<div class="col-md-4 text-right">
								<base-button
									type="warning"
									size="sm"
									@click="handleClearNoTracking"
									:loading="isClearingTracking"
								>
									Clear No Tracking
								</base-button>
							</div>
						</div>


                        <div class="row" v-else>
                                <base-input v-if="isSearchAdvance" class="col-md-2 col-xs-12">
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true }"
                                        :placeholder="$t('time_from')"
                                        class="form-control datepicker"
                                        v-model="params.time_from"
                                    >
                                    </flat-picker>
                                </base-input>

                            <div class="col-md-2 col-xs-12">
                                <base-input>
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true }"
                                        :placeholder="$t('time_to')"
                                        class="form-control datepicker"
                                        v-model="params.time_to"
                                    >
                                    </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-lg-3">
                                <base-input
								:label="keywordType"
                                    v-model="params.order_number"
                                    placeholder="หมายเลขสั่งซื้อ, เบอร์โทร, ชื่อ, Tracking"
									v-on:keyup.enter="handleSearch"
                                >
                                </base-input>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="params.bo_user_id"
                                        :placeholder="$t('menu.user')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in OptionUserTable"
                                            :key="option.UserID"
                                            :label="option.fname + ' ' + option.lname"
                                            :value="option.UserID"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

                            <!-- <div class="col-md-2" v-if="isSearchAdvance">
                                <base-input>
                                    <el-select
                                        v-model="params.bo_team_id"
                                        :placeholder="$t('menu.team')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in OptionTeamTable"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div> -->

                            <div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="params.order_status"
                                        :placeholder="$t('menu.order_status')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in OrderStatusTable"
                                            :key="option.ID"
                                            :label="option.Name"
                                            :value="option.ID"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							 <div class="col-md-2" v-if="isSearchAdvance">
                                <base-input>
                                    <el-select
                                        v-model="params.payment_method_type"
                                        :placeholder="$t('payment_method_type')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in PaymentMethodTypeTable"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2"  v-if="isSearchAdvance">
                                <base-input>
                                    <el-select
                                        v-model="params.bo_sale_channel_id"
                                        :placeholder="$t('sale_channel')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in SaleChannelTableWithAll"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2"  v-if="isSearchAdvance">
                                <base-input>
                                    <el-select
                                        v-model="params.bo_sale_channel_type_id"
                                        :placeholder="$t('sale_channel_type')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in SaleChannelTypeTableWithAll"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2"  v-if="isSearchAdvance">
                                <base-input>
                                    <el-select
                                        v-model="params.bo_platform_id"
                                        :placeholder="$t('platform')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in PlatformTableWithAll"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2"  v-if="isSearchAdvance">
                                <base-input>
                                    <el-select
                                        v-model="params.packing_not_close"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in PackingStatusTable"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<!-- <div class="col-lg-2">
                                <base-input
                                    v-model="params.recipient_name"
                                    :placeholder="$t('recipient_name')"
									v-on:keyup.enter="handleSearch"
                                >
                                </base-input>
                            </div>

							 <div class="col-lg-2">
                                <base-input
                                    v-model="params.recipient_phone"
                                    :placeholder="$t('recipient_phone')"
									v-on:keyup.enter="handleSearch"
                                >
                                </base-input>
                            </div>

							 <div class="col-lg-2">
                                <base-input
                                    v-model="params.tracking_number"
                                    :placeholder="$t('tracking_number')"
									v-on:keyup.enter="handleSearch"
                                >
                                </base-input>
                            </div> -->

							<div class="col-lg-2" v-if="showForceFilterDate">
								<base-checkbox
								v-model="params.force_filter_date" class="mb-3">
								ค้นหาโดยใช้วันที่
								</base-checkbox>
							</div>

                            <div class="col-auto">
                                <base-button size="md" @click="handleSearch()">
								<i class="fas fa-spinner fa-spin " v-if="isLoading"></i>
                                    {{ $t("search") }}</base-button
                                >
                                <base-button size="md" @click="searchMode = 'basic'" v-if="isSearchAdvance"> Basic</base-button>
                                <base-button size="md" @click="searchMode = 'advance'" v-if="isSearchBasic"> Advance</base-button>
                                <base-button size="md" :loading="isLoading" @click="handleExport()" v-if="isSearchAdvance"> Export</base-button>
                                <base-button size="md" :loading="isExportLoading" @click="handleExportDetail()" v-if="isSearchAdvance"> Export Detail</base-button>
                            </div>

                        </div>

                    </template>
                    <!-- end header -->

                    <div v-if="activeTab === 'all'">
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                            cell-class-name="bo-orders-cell"
                            header-cell-class-name="bo-orders-cell"
                        >
                            <!-- order_number -->
                            <el-table-column
                                align="left"
                                :label="$t('order_number')"
                                min-width="70px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.ID }} </span>
                                </div>
                            </el-table-column>

                            <!-- created_at -->
                            <el-table-column
                                align="left"
                                :label="$t('created')"
                                min-width="155px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.created_at }} </span>
                                </div>
                            </el-table-column>

                            <!-- order_platform -->
                            <el-table-column
                                align="left"
                                :label="$t('sale_channel')"
                                min-width="120px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    {{
                                        GetSaleChannelName(
                                            row.bo_sale_channel_id
                                        )
                                    }}
                                </div>
                            </el-table-column>

                            <!-- recipient_name -->
                            <el-table-column
                                align="left"
                                :label="$t('recipient_name')"
                                min-width="150px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.recipient_name }} </span>
                                </div>
                            </el-table-column>

                            <!-- price -->
                            <el-table-column
                                align="right"
                                :label="$t('price')"
                                min-width="90px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.pay_amount }} </span>
                                </div>
                            </el-table-column>

                            <!-- recipient_phone -->
                            <el-table-column
                                align="left"
                                :label="$t('recipient_phone')"
                                min-width="100px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.recipient_phone }} </span>
                                </div>
                            </el-table-column>

                            <!-- bo_order_user -->
                            <el-table-column
                                align="left"
                                :label="$t('order_user')"
                                min-width="100px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.bo_order_user_name }} </span>
                                </div>
                            </el-table-column>

                            <!-- traccking -->
                            <el-table-column
                                align="left"
                                :label="$t('tracking_number')"
                                min-width="100px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span @click="handleCheckTracking(row.shipping_provider_id,row.shipping_tracking_number)"> {{ row.shipping_tracking_number }} </span>
                                </div>
                            </el-table-column>


                            <el-table-column
                                align="left"
                                :label="$t('status')"
                                min-width="132px"
                            >
                                <div slot-scope="{ row }" class="d-flex flex-wrap align-items-center">
                                    <template v-if="row.order_status == 100"> <span class="btn btn-sm"> {{ $t("order_status_unpaid")}} </span> </template>
                                    <template v-if="row.order_status == 111"> <span class="btn btn-info btn-sm"> {{ $t("order_status_awaiting_shipment") }} </span></template>
                                    <template v-if="row.order_status == 112"> <span class="btn btn-info btn-sm"> {{ $t("order_status_awaitingcollection") }} </span></template>
                                    <template v-if="row.order_status == 114"> <span class="btn btn-info btn-sm"> {{ $t("order_status_partiallyshipping") }} </span></template>
                                    <template v-if="row.order_status == 115"> <span class="btn btn-info btn-sm"> {{ $t("order_status_awaiting_transit") }} </span></template>
                                    <template v-if="row.order_status == 121"> <span class="btn btn-primary btn-sm"> {{ $t("order_status_intransit") }} </span></template>
                                    <template v-if="row.order_status == 122"> <span class="btn btn-primary btn-sm"> {{ $t("order_status_delivered") }} </span></template>
                                    <template v-if="row.order_status == 130"> <span class="btn btn-success btn-sm"> {{ $t("order_status_completed") }} </span></template>
                                    <template v-if="row.order_status == 140"> <span class="btn btn-danger btn-sm"> {{ $t("order_status_cancelled") }} </span></template>
                                    <template v-if="row.order_status == 141"> <span class="btn btn-danger btn-sm"> {{ $t("order_status_returned") }} </span></template>
                                    <template v-if="row.order_status == 142"> <span class="btn btn-danger btn-sm"> {{ $t("order_status_claimed") }} </span></template>
                                    <template v-if="row.order_status == 143"> <span class="btn btn-warning btn-sm"> {{ $t("order_status_returning") }} </span></template>
                                    <!-- Shopee cancel reconcile §11 F1 (spec 2026-10-07-shopee-cancel-reconcile-design.md):
                                         Shopee IN_CANCEL on a live row = orange "cancel requested"; a 140 row whose stored
                                         Shopee status is not CANCELLED shows that status (it may be stale). Own line. -->
                                    <div v-if="statusExtras(row).cancelRequested || statusExtras(row).staleChip" class="w-100">
                                        <span v-if="statusExtras(row).cancelRequested" class="badge badge-warning mt-1" data-testid="status-cancel-requested">{{ $t("orders_new.cancel_requested") }}</span>
                                        <span v-if="statusExtras(row).staleChip" class="badge badge-secondary mt-1" data-testid="status-stale-chip" :title="$t('orders_new.platform_status_stale')">{{ statusExtras(row).staleChip }}</span>
                                    </div>
                                    <!-- /S4 F1 -->

                                </div>
                            </el-table-column>

                            <el-table-column
                                align="right"
                                :label="$t('actions')"
                                min-width="170px"
                            >
                                <div
                                    slot-scope="{ $index, row }"
                                    class="d-flex"
                                >
                                    <!-- <base-button
                                        @click.native="
                                            handlePayment($index, row)
                                        "
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-edit"></i>
                                    </base-button> -->
                                    <base-button
                                        @click.native="
                                            handleDetail(row)
                                        "
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-edit"></i>
                                    </base-button>

									<base-button v-if="(row.order_status == 100)"
                                        @click.native="handleChangeShipping(row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fas fa-shipping-fast"></i>
                                    </base-button>

									<!-- #931: + 140 (cancelled) — allowed for admins, the dialog warns. 2026-10-15 owner: + 111/114/122. -->
									<base-button v-if="(row.order_status == 130 || row.order_status == 111 || row.order_status == 112  || row.order_status == 114 || row.order_status == 115 || row.order_status == 121 || row.order_status == 122 || row.order_status == 140) && isAdmin"
                                        @click.native="handleChangeTracking(row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-truck"></i>
                                    </base-button>

                                    <!-- #189 จำลอง (staging): MDFStore orders only — BE sets
                                         row.simulate_enabled when the config flag is on -->
                                    <template v-if="row.simulate_enabled && canSimulate(row.order_status)">
                                        <base-button
                                            @click.native="handleSimulate(row, 'delivered')"
                                            class="edit"
                                            type="success"
                                            size="sm"
                                            icon
                                            :title="$t('sim_delivered')"
                                        >
                                            <i class="text-dtac-bt fa fa-check"></i>
                                        </base-button>
                                        <base-button
                                            @click.native="handleSimulate(row, 'failed')"
                                            class="edit"
                                            type="danger"
                                            size="sm"
                                            icon
                                            :title="$t('sim_failed')"
                                        >
                                            <i class="text-dtac-bt fa fa-times"></i>
                                        </base-button>
                                        <base-button
                                            @click.native="handleSimulate(row, 'returned')"
                                            class="edit"
                                            type="warning"
                                            size="sm"
                                            icon
                                            :title="$t('sim_returned')"
                                        >
                                            <i class="text-dtac-bt fa fa-undo"></i>
                                        </base-button>
                                    </template>

                                    <base-button
                                        @click.native=" handleDelete($index, row) "
                                        class="remove btn-link"
                                        type="danger"
                                        size="sm"
                                        icon
										v-if="isAccessDeleleteOrder(row.order_status)"
                                    >
                                        <i class="text-dtac-bt fa fa-trash text-white"></i>
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>

                    <!-- Return-in-transit (กำลังตีกลับ / status 143) queue -->
                    <div v-if="activeTab === 'return'">
                        <el-table
                            :data="ReturnInTransitData"
                            row-key="ID"
                            header-row-class-name="thead-light"
                        >
                            <!-- order id -->
                            <el-table-column
                                align="left"
                                :label="$t('order_number')"
                                min-width="80px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <a href="#" @click.prevent="handleDetail(row)">{{ row.ID }}</a>
                                </div>
                            </el-table-column>

                            <!-- return_started_at + age -->
                            <el-table-column
                                align="left"
                                :label="$t('return_started_at')"
                                min-width="150px"
                            >
                                <div slot-scope="{ row }" class="d-flex flex-column">
                                    <span>{{ row.return_started_at }}</span>
                                    <small
                                        v-if="returnAgeDays(row.return_started_at) !== null"
                                        :class="returnAgeDays(row.return_started_at) > 7 ? 'text-danger font-weight-bold' : 'text-muted'"
                                    >
                                        {{ $t("return_age_days", { n: returnAgeDays(row.return_started_at) }) }}
                                    </small>
                                </div>
                            </el-table-column>

                            <!-- return_source badge -->
                            <el-table-column
                                align="left"
                                :label="$t('return_source')"
                                min-width="110px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span class="btn btn-secondary btn-sm">
                                        {{ ReturnSourceLabel(row.return_source) }}
                                    </span>
                                </div>
                            </el-table-column>

                            <!-- platform / sale channel -->
                            <el-table-column
                                align="left"
                                :label="$t('platform')"
                                min-width="100px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    {{ GetPlatformName(row.platform_id) }}
                                </div>
                            </el-table-column>

                            <el-table-column
                                align="left"
                                :label="$t('sale_channel')"
                                min-width="120px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    {{ GetSaleChannelName(row.bo_sale_channel_id) }}
                                </div>
                            </el-table-column>

                            <!-- recipient -->
                            <el-table-column
                                align="left"
                                :label="$t('recipient_name')"
                                min-width="150px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span>{{ row.recipient_name }}</span>
                                </div>
                            </el-table-column>

                            <!-- tracking with copy -->
                            <el-table-column
                                align="left"
                                :label="$t('tracking_number')"
                                min-width="160px"
                            >
                                <div slot-scope="{ row }" class="d-flex align-items-center">
                                    <span>{{ row.shipping_tracking_number }}</span>
                                    <el-tooltip
                                        v-if="row.shipping_tracking_number"
                                        content="Copy"
                                        placement="top"
                                    >
                                        <i
                                            class="fa fa-copy ml-2"
                                            style="cursor:pointer"
                                            @click="copyTracking(row.shipping_tracking_number)"
                                        ></i>
                                    </el-tooltip>
                                </div>
                            </el-table-column>

                            <!-- status badge -->
                            <el-table-column
                                align="left"
                                :label="$t('status')"
                                min-width="120px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span class="btn btn-warning btn-sm">
                                        {{ $t("order_status_returning") }}
                                    </span>
                                </div>
                            </el-table-column>

                            <!-- actions -->
                            <el-table-column
                                align="right"
                                :label="$t('actions')"
                                min-width="90px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <base-button
                                        @click.native="handleDetail(row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-edit"></i>
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>

                    <div
                        slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="activeTab === 'all' && tableData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <!-- Rows per page (10/20/50/100), remembered in localStorage
                             -- never in the URL: this path is query-keyed in the
                             taskbar (spec 2026-10-07-bo-orders-pagination-size §3 P2-P4). -->
                        <div class="d-flex align-items-center flex-wrap">
                            <span class="text-muted mr-2">{{ $t("orders_new.page_size") }}</span>
                            <el-select
                                v-model="pagination.perPage"
                                size="mini"
                                style="width: 120px"
                                class="mr-3 bo-orders-page-size"
                                @change="onPageSizeChange"
                            >
                                <el-option
                                    v-for="n in pageSizes"
                                    :key="n"
                                    :label="$t('orders_new.page_size_option', { n })"
                                    :value="n"
                                ></el-option>
                            </el-select>
                            <base-pagination
                                class="pagination-no-border"
                                v-model="pagination.currentPage"
                                :per-page="pagination.perPage"
                                :total="total"
                            >
                            </base-pagination>
                        </div>
                    </div>

                    <div
                        slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="activeTab === 'return' && ReturnInTransitTotal != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("of") }} {{ ReturnInTransitTotal }}
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="returnParams.page"
                            :per-page="returnParams.per_page"
                            :total="ReturnInTransitTotal"
                            @input="handleReturnPageChange"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>


		<!-- bo-api #931: admins set / change the tracking number through
		     PUT /orders/tracking-attach/:id (round lock + audit; replace confirmed). -->
		<change-tracking-dialog
			:visible.sync="showChangeTrackingModal"
			:order="orderDetail"
			@saved="onTrackingChanged"
		>
			<template slot="footer-extra">
				<!-- mirakl Dev-B2: retry ship (OR23->OR24) for Makro orders, with the saved number. -->
				<button
					v-if="Number(orderDetail.platform_id) === 10"
					type="button"
					class="btn btn-md btn-link btn-warning text-white"
					:disabled="miraklBusy"
					@click="handleMiraklShip()"
				>
					{{ $t("makro_order.ship_to_makro") }}
				</button>
			</template>
		</change-tracking-dialog>

		<modal
            :show.sync="showChangeShippingModal"
            modal-classes="modal-secondary modal-lg"
        >
            <div class="row">
                <div class="col-md-12">
                    <h5 class="modal-title">
                        แก้ไขช่องทางการจัดส่ง - {{ $t("order_number") }} : {{ orderDetail.ID }} - สถานะ
                        : {{ GetOrderStatus(orderDetail.order_status) }}
                    </h5>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
					 <base-input>
						<el-select
							v-model="shipping_provider_id"
							:placeholder="$t('shipping_provider')"
						>
							<el-option
								v-for="option in ShippingProviderTable"
								:key="option.id"
								:label="option.name"
								:value="option.id"
							>
							</el-option>
						</el-select>
					</base-input>

                </div>
            </div>

			  <template slot="footer">
				<!-- Payment Check Success -->
				<button
                    type="button"
                    class="btn btn-md btn-link ml-auto btn-primary text-white"
                    @click="handleUpdateShipping()"
                >
                    {{ $t("save") }}
                </button>
			  </template>

		</modal>

        <modal
            :show.sync="showDetailModal"
            modal-classes="modal-secondary modal-lg"
        >
            <div class="row">
                <div class="col-md-12">
                    <h5 class="modal-title">
                        {{ $t("order_detail") }} : {{ orderDetail.ID }} - สถานะ
                        : {{ GetOrderStatus(orderDetail.order_status) }}
                    </h5>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <base-input
                        label="ผู้สั่งซื้อ"
                        :value="orderDetail.recipient_name"
                    ></base-input>
                </div>
                <div class="col-md-3">
                    <base-input
                        label="โทรศัพท์"
                        :value="orderDetail.recipient_phone"
                    ></base-input>
                </div>

				  <div class="col-md-3">
                    <base-input
                        label="วันที่"
                        :value="orderDetail.created_at"
                    ></base-input>
                </div>
            </div>

            <div class="row">

                <div class="col-md-6" v-if="orderDetail.discount == 0">
                    <base-input
                        label="ราคา"
                        :value="orderDetail.pay_amount"
                    ></base-input>
                </div>
				 <div class="col-md-3" v-if="orderDetail.discount != 0">
                    <base-input
                        label="ส่วนลด"
                        :value="orderDetail.discount"
                    ></base-input>
                </div>
				 <div class="col-md-3" v-if="orderDetail.discount != 0">
                    <base-input
                        label="ราคา (หักส่วนลด)"
                        :value="orderDetail.pay_amount"
                    ></base-input>
                </div>

                <div class="col-md-3">
                    <base-input
                        label="ช่องทางการชำระเงิน"
                        :value="orderDetail.payment_method_name"
                    ></base-input>
                </div>
                <div class="col-md-3">
                    <base-input
                        label="พนักงานผู้ตรวจสอบ"
                        :value="orderDetail.bo_payment_user_name"
                    ></base-input>
                </div>
            </div>

			<div class="row" v-if="orderDetail.shipping_cost != 0">
				<div class="col-md-3">
				<base-input
                        label="ค่าจัดส่ง"
                        :value="orderDetail.shipping_cost"
                    ></base-input>
				</div>
			</div>

            <!--  full adress -->
            <div class="row">
                <div class="col-md-8">
                    <base-input
                        label="ที่อยู่"
                        :value="orderDetail.recipient_address_fulladdress + ' ' + orderDetail.recipient_zipcode"
                    ></base-input>
                </div>
                <div class="col-md-4">
                    <base-input
                        label="หมายเหตุ"
                        :value="orderDetail.seller_note"
                    ></base-input>
                </div>
            </div>

			<div class="row" v-if="orderDetail.order_status >= 140">
                <div class="col-md-4">
                    <base-input
                        label="เหตุผลการยกเลิก"
                        :value="GetCancelReasonName(orderDetail.bo_cancel_reason_id)"
                    ></base-input>
                </div>
                <div class="col-md-4">
                    <base-input
                        label="รายละเอียด"
                        :value="orderDetail.cancel_reason"
                    ></base-input>
                </div>
                <div class="col-md-4">
                    <base-input
                        label="ผู้ยกเลิก"
                        :value="orderDetail.bo_cancel_user_name"
                    ></base-input>
                </div>
            </div>

			<div class="row" v-if="orderDetail.order_status >= 140 && orderDetail.bo_cancel_reason_id == 5">
					<label>รูปภาพสินค้าเคลม</label>
				<div class="col-md-12" v-if="orderDetail.images != ''">
					<img v-for="f in orderDetail.images.split(',')" :key="f" :src="GetClaimImage(f)" style="width: 200px; " />
				</div>
			</div>

			<div class="row">
                <div class="col-md-4">
                    <base-input
                        label="ขนส่ง"
                        :value="orderDetail.shipping_provider_name"
                    ></base-input>
                </div>
                <div class="col-md-4" v-if="orderDetail.order_status == 130 || orderDetail.order_status == 115 || orderDetail.order_status == 121 || orderDetail.order_status == 122">
                    <base-input
                        label="หมายเลขพัสดุ"
                        :value="orderDetail.shipping_tracking_number"
                    ></base-input>
                </div>
                <div class="col-md-4" v-if="orderDetail.order_status == 130 || orderDetail.order_status == 115 || orderDetail.order_status == 121 || orderDetail.order_status == 122">
                    <base-input
                        label="ผู้จัดส่ง"
                        :value="orderDetail.bo_shipping_user_name"
                    ></base-input>
                </div>

            </div>

			<div class="row" v-if="orderDetail.platform_id != 1">
                <div class="col-md-4">
                    <base-input
                        label="Platform Order ID"
                        :value="orderDetail.platform_order_id"
                    ></base-input>
                </div>
                <div class="col-md-4">
                    <base-input
                        label="Platform Order Status"
                        :value="orderDetail.platform_order_status"
                    ></base-input>
                </div>
                <div class="col-md-4">
                    <base-input
                        label="หมายเลขพัสดุ"
                        :value="orderDetail.shipping_tracking_number"
                    ></base-input>
                </div>
            </div>

            <!-- Tracking timeline (Thaipost / SPX) — collapsed by default
                 because a long history can crowd the detail modal. Click
                 the header to expand. -->
            <div class="row" v-if="trackingTimeline && trackingTimeline.timeline && trackingTimeline.timeline.length > 0">
                <div class="col-md-12">
                    <div class="card bg-secondary">
                        <div
                            class="card-header py-2 d-flex justify-content-between align-items-center"
                            style="cursor: pointer; user-select: none;"
                            @click="trackingTimelineExpanded = !trackingTimelineExpanded">
                            <div>
                                <i class="fa" :class="trackingTimelineExpanded ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                                <strong class="ml-2">Tracking Timeline</strong>
                                <span class="badge badge-pill badge-light ml-2">{{ trackingTimeline.timeline.length }}</span>
                                <small class="text-muted ml-2" v-if="trackingTimeline.last_updated_at">
                                    อัพเดทล่าสุด {{ formatTimelineTs(trackingTimeline.last_updated_at) }}
                                </small>
                            </div>
                        </div>
                        <div class="card-body py-2" v-show="trackingTimelineExpanded">
                            <ul class="list-unstyled mb-0">
                                <li v-for="(ev, i) in sortedTimeline" :key="i" class="py-1">
                                    <span class="badge badge-pill"
                                        :class="ev.source !== 'webhook' ? (ev.source === 'refresh' ? 'badge-warning' : 'badge-info') : ''"
                                        :style="ev.source === 'webhook' ? 'background:#ffffff;border:1px solid #1e40af;color:#1e3a8a;' : ''">
                                        {{ ev.source }}
                                    </span>
                                    <code class="ml-2">{{ ev.status_code }}</code>
                                    <strong class="ml-2">{{ timelineStatusLine(ev) }}</strong>
                                    <span class="text-muted ml-2">— {{ formatTimelineTs(ev.ts) }}</span>
                                    <div v-if="timelineLocation(ev)" class="text-muted small ml-5">
                                        <i class="fa fa-map-marker-alt"></i> {{ timelineLocation(ev) }}
                                    </div>
                                    <div v-if="timelineOffice(ev)" class="text-muted small ml-5">
                                        <i class="fa fa-building"></i> {{ timelineOffice(ev) }}
                                        <span v-if="timelineOfficeTel(ev)">— <i class="fa fa-phone"></i> {{ timelineOfficeTel(ev) }}</span>
                                    </div>
                                    <div v-if="ev.message" class="text-muted small ml-5">{{ ev.message }}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

			<div class="row">
                <div class="col-md-4">
                    <base-input
                        label="ผู้เปิด Order แพ็ค"
                        :value="orderDetail.packing_opened_user_name"
                    ></base-input>
                </div>
                <div class="col-md-4">
                    <base-input
                        label="เวลาเปิด Order แพ็ค"
                        :value="orderDetail.packing_opened_at"
                    ></base-input>
                </div>
                <div class="col-md-4">
                    <base-input
                        label="เวลาปิด Order แพ็ค"
                        :value="orderDetail.packing_closed_at"
                    ></base-input>
                </div>

            </div>

			<div class="row">
                <div class="col-md-4">
                    <base-input
                        :label="$t('line_packing')"
                        :value="GetStorageName(orderDetail.packing_opened_storage_id)"
                    ></base-input>
                </div>
            </div>

			<div class="row" v-if="orderDetail.bo_packing_id != 0">
				<div class="col-md-12">
					<base-button class="edit" size="sm" icon @click="handlePackingByID()">
							หมายเลขตัดรอบ : {{ orderDetail.bo_packing_id}}
					</base-button>

					<!-- <base-button class="edit" size="sm" icon @click="handlePrintDocument('A4')">
							พิมพ์ใบปะหน้า : (A4)
					</base-button> -->
					<!-- <base-button class="edit" size="sm" icon @click="handlePrintDocument('100x75')">
							พิมพ์ใบปะหน้า : (100x75)
					</base-button> -->
					<base-button class="edit" size="sm" icon @click="handlePrintDocument('100x150')">
							พิมพ์ใบปะหน้า : (100x150)
					</base-button>


				</div>
			</div>


            <hr />
			<div class="row">
				<div class="col-md-12">
					--- สินค้าที่สั่งซื้อ ---
				</div>
			</div>
			<div class="col-md-12" v-if="Detail.order_items == undefined">
				<span > <i class="fas fa-spinner fa-spin"></i>
				กำลังประมวลผล...</span>
			</div>
			<div class="row" v-for="( value) in Detail.order_items" :key="value.id" >
				<div class="col-md-10">
					{{ value.bo_product_name }} : {{ value.bo_product_sku_name  }}
				</div>
				<div class="col-md-2">x {{ value.quantity }} </div>
			</div>
			<!-- <div class="row">
				<div class="col-md-12">
					--- สินค้าที่ตัดสต๊อก ---
				</div>
			</div>
			<div class="row" v-for="( value) in GetWmsProductSummary()" :key="value.wms_product_id" >
				<div class="col-md-10">
					{{ value.wms_product_name }}  ({{value.barcode }})
				</div>
				<div class="col-md-2">x {{ value.pickup_quantity }} </div>
			</div> -->
            <hr />

			<div class="row" v-if="!IsCod">
				<div class="col-md-6">
					<base-input
                        label="เวลาที่ชำระเงิน"
                        :value="orderDetail.payment_at"
                    ></base-input>

				</div>
			</div>

			<div class="row" v-if="Detail.payment_files != ''">
				<div class="col-md-6">
					<base-input
						label="หลักฐานการชำระเงิน"
					>
					<img :src="DetailImage" style="width: 500px; " v-if="DetailImage != ''"/>
					</base-input>

				</div>
			</div>


            <template slot="footer">
                <!-- Shipping Video Buttons (for InTransit/Complete orders) -->
                <base-button
                    v-if="(orderDetail.order_status === 115 || orderDetail.order_status === 121 || orderDetail.order_status === 130) && shippingVideoDownloadData && shippingVideoDownloadData.file_exists"
                    type="info"
                    size="md"
                    @click="viewShippingVideo"
                    :disabled="isLoadingShippingVideo"
                    class="mr-2"
                >
                    <i class="fa fa-eye mr-2"></i>
                    View Shipping Video
                </base-button>

                <base-button
                    v-if="(orderDetail.order_status === 115 || orderDetail.order_status === 121 || orderDetail.order_status === 130) && shippingVideoDownloadData && shippingVideoDownloadData.file_exists"
                    type="success"
                    size="md"
                    @click="downloadShippingVideo"
                    :disabled="isLoadingShippingVideo"
                    class="mr-2"
                >
                    <i class="fa fa-download mr-2"></i>
                    Download Shipping Video
                </base-button>

                <!-- Loading indicator for shipping video fetch -->
                <base-button
                    v-if="(orderDetail.order_status === 115 || orderDetail.order_status === 121 || orderDetail.order_status === 130) && isLoadingShippingVideo"
                    type="info"
                    size="md"
                    disabled
                    class="mr-2"
                >
                    <i class="fa fa-spinner fa-spin mr-2"></i>
                    Checking Shipping Video...
                </base-button>

                <!-- No shipping video available message -->
                <span
                    v-if="(orderDetail.order_status === 115 || orderDetail.order_status === 121 || orderDetail.order_status === 130) && !isLoadingShippingVideo && (!shippingVideoDownloadData || !shippingVideoDownloadData.file_exists)"
                    class="text-muted mr-3"
                >
                    <i class="fa fa-info-circle mr-1"></i>
                    No shipping video available
                </span>

                <!-- Return Video Buttons (for Returned orders) -->
                <base-button
                    v-if="orderDetail.order_status === 141 && videoDownloadData && videoDownloadData.file_exists"
                    type="info"
                    size="md"
                    @click="viewVideo"
                    :disabled="isLoadingVideo"
                    class="mr-2"
                >
                    <i class="fa fa-eye mr-2"></i>
                    View Return Video
                </base-button>

                <base-button
                    v-if="orderDetail.order_status === 141 && videoDownloadData && videoDownloadData.file_exists"
                    type="success"
                    size="md"
                    @click="downloadVideo"
                    :disabled="isLoadingVideo"
                    class="mr-2"
                >
                    <i class="fa fa-download mr-2"></i>
                    Download Return Video
                </base-button>

                <!-- Loading indicator for return video fetch -->
                <base-button
                    v-if="orderDetail.order_status === 141 && isLoadingVideo"
                    type="info"
                    size="md"
                    disabled
                    class="mr-2"
                >
                    <i class="fa fa-spinner fa-spin mr-2"></i>
                    Checking Return Video...
                </base-button>

                <!-- No return video available message -->
                <span
                    v-if="orderDetail.order_status === 141 && !isLoadingVideo && (!videoDownloadData || !videoDownloadData.file_exists)"
                    class="text-muted mr-3"
                >
                    <i class="fa fa-info-circle mr-1"></i>
                    No return video available
                </span>

                <!-- mirakl Dev-B2: accept a Makro (Mirakl) order awaiting acceptance. -->
                <base-button
                    v-if="Number(orderDetail.platform_id) === 10 && orderDetail.platform_order_status === 'WAITING_ACCEPTANCE'"
                    type="success"
                    size="md"
                    class="mr-2"
                    :loading="miraklBusy"
                    @click="handleMiraklAccept()"
                >
                    <i class="fa fa-check mr-2"></i>
                    {{ $t("makro_order.accept") }}
                </base-button>

                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showDetailModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>


		<modal
            :show.sync="showCancelModal"
            modal-classes="modal-secondary modal-lg"
        >
            <div class="row">
                <div class="col-md-12">
                    <h5 class="modal-title">
                        ยกเลิกรายการสั่งซื้อ : {{ orderDetail.ID }}   ผู้สั่งซื้อ : {{ orderDetail.recipient_name }}
                    </h5>
                </div>
            </div>
			<div class="row">
                <div class="col-md-6">
					<base-input label="ประเภทการยกเลิก">
						<el-select v-model="params_cancel.bo_cancel_reason_id" >
							<el-option
								v-for="option in CancelReasonTable"
								:key="option.ID"
								:label="option.Name"
								:value="option.ID"
							>
							</el-option>
						</el-select>
					</base-input>
                </div>
			</div>
			<div class="row">
                <div class="col-md-8">

                    <base-input
                        label="เหตุผลการยกเลิก"
                        v-model="params_cancel.cancel_reason"
                    ></base-input>
                </div>
                <div class="col-md-4" v-if="params_cancel.bo_cancel_reason_id == 5">
                    <base-input
                        label="หมายเลขสั่งซื้อใหม่"
                        v-model="params_cancel.rder_claim_to_id"
                    ></base-input>
                </div>
            </div>

			<div class="row"  v-if="params_cancel.bo_cancel_reason_id == 5">
				<!-- Upload Image -->
				<div class="col-md-12">
					<base-input label="ภาพสินค้า" name="product_claim_image" v-if="params_cancel.images.length < 6">
						<file-input rules="required" @change="claimFilesChange" ></file-input>
					</base-input>

					<img v-for="i in params_cancel.images" :key="i" :src="i" style="width: 200px; " />
				</div>
			</div>

			<template slot="footer">
				<button
                    type="button"
                    class="btn btn-md btn-primary text-white"
                    @click="handelUpdateCancel()"
                >
                    {{ $t("confirm_cancel") }}
                </button>

                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showCancelModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from 'moment'
import FileInput from "@/components/Inputs/FileInput";
import { undistributeHeight } from '@fullcalendar/core';
import { read, utils, writeFile } from 'xlsx'
import { OrderService } from "@/resource";
import ChangeTrackingDialog from "@/components/Orders/ChangeTrackingDialog.vue";
import { canDeleteOrder } from "@/utils/orderDelete";
import { BO_CANCEL_REASONS } from "@/utils/orderCancelReason";
import { arrivalIntent } from "@/utils/pageRefresh";
import { taskbarKey } from "@/utils/taskbar";
import { sidebarResetRequests, consumeSidebarReset, defaultOrderListParams } from "@/utils/sidebarReset";
import { PAGE_SIZES, normalizeSize } from "@/utils/ordersNew";
import { rowActionFromRoute, rowActionAllowed } from "@/utils/ordersNew";
import { orderStatusExtras } from "@/utils/ordersNew";
import { ORDERS_PAGE_SIZE_KEY, readPageSize, writePageSize } from "@/utils/pageSizePref";
// §20 R48 (#432): the timeline helpers live in a util shared with OrdersNew.vue.
import * as trackingTimelineUtil from "@/utils/trackingTimeline";

// localStorage when there is a window (always, in the browser); null keeps
// readPageSize/writePageSize on their default path otherwise.
function pageSizeStorage() {
    return typeof window !== "undefined" ? window.localStorage : null;
}

export default {
    mixins: [clientPaginationMixin],
    components: {
        ChangeTrackingDialog,
        flatPicker,
		FileInput,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        // A sidebar click on รายการสั่งซื้อ flagged this tab (src/utils/sidebarReset.js).
        sidebarResetPending() {
            return sidebarResetRequests.keys[this.ownTaskbarKey] === true;
        },
        // Timeline newest-last (carrier already returns ascending; UI
        // shows them in event order so the most recent appears at the
        // bottom). Defensive sort in case the backend response is out
        // of order. (#432: sortTimelineAsc in @/utils/trackingTimeline.)
        sortedTimeline() {
            return trackingTimelineUtil.sortTimelineAsc(trackingTimelineUtil.timelineEvents(this.trackingTimeline));
        },
        ...mapGetters({
            tableData: "Order/getData",
            UserTable: "User/getData",
            SaleChannelTable: "SaleChannel/getData",
            TeamTable: "Team/getData",
            PaymentMethodTable: "PaymentMethod/getData",
            Detail: "Order/getDatum",
            isLoading: "Order/isLoading",
			PaymentMethodTypeTable:"PaymentMethod/getPaymentMethodTypeTableWithAll",
			setPaymentCurrentPage: "Order/getPaymentCurrentPage",
            getOrderCurrentPage: "Order/getOrderCurrentPage",
			OrderStatusTable: "Order/OrderStatusTableWithAll",
            SaleChannelTableWithAll: "SaleChannel/getDataWithAll",
            SaleChannelTypeTableWithAll: "SaleChannel/getDataTypeWithAll",
			ShippingProviderTable : "Order/getShippingProvider",
			PlatformTable : "Order/getPlatformTable",
			PlatformTableWithAll : "Order/getPlatformTableWithAll",
			ReturnInTransitData : "Order/getReturnInTransit",
			ReturnInTransitTotal : "Order/getReturnInTransitTotal",
			isReturnInTransitLoading : "Order/isReturnInTransitLoading",
			StorageTable: "WmsStorage/getData",

			isAdmin : "Auth/isAdmin",
			isOwner : "Auth/isOwner",
			isEmployee : "Auth/isEmployee",
			isAgent : "Auth/isAgent",
			isExpress : "Auth/isExpress",
			isCustomer : "Auth/isCustomer",
			isAccessPayment: "Auth/isAccessPayment"
        }),
		keywordType(){
			let keyword = this.params.order_number

			// check is mobile number , number[10] , start with 0
			var regIsMobileNumber = /^[0]\d{9}$/g;
			var regIsOrderMdfNumber = /MDF\d{1,12}$/gi;
			var regIsOrderNumber = /^\d{1,12}$/g;
			var regIsThaipost = /^[A-Z]{2}\d{9}[A-Z]{2}$/gi;
			var regIsKerry = /^[A-Z]{4}\d{9}$/gi;
			var regIsKerryLazada = /^[A-Z]{5}\d{10}$/gi;
			var regIsKerryShopee = /^SD[A-Z]{2}\d{10}$/gi;
			var regIsDHL = /^[A-Z]{5}\d{10}$/gi;
			var regIsFlash = /^TH[0-9A-Z]{12,13}$/gi;
			var regIsJT = /^[0-9]{12}$/gi;
			var regIsSPX = /^SPX[0-9A-Z]{12,14}$/gi;

			console.log("Keyword:",keyword)

            // #122: MDF-like platforms (all=0, MDF=1, MDFStore=9) classify the
            // keyword by regex; only true marketplaces default to tracking search.
            if (this.params.bo_platform_id != 0 && this.params.bo_platform_id != 1 && this.params.bo_platform_id != 9 )
            {
                return "Tracking";
            }

			if(regIsMobileNumber.test(keyword)){
				return "เบอร์โทรศัพท์";
			}

			// check is order id  ,  start with mdf , number only
			if(regIsOrderMdfNumber.test(keyword)){
				return "หมายเลขสั่งซื้อ";
			}

			if(regIsOrderNumber.test(keyword)){
				return "หมายเลขสั่งซื้อ";
			}

			if(regIsThaipost.test(keyword)){
				return "Tracking : Thaipost";
			}

			if(regIsKerry.test(keyword)){
				return "Tracking : Kerry";
			}

			if(regIsKerryLazada.test(keyword)){
				return "Tracking : Kerry";
			}

			if (regIsKerryShopee.test(keyword)){
				return "Tracking : Kerry";
			}
			if (regIsDHL.test(keyword)){
				return "Tracking : DHL";
			}
			if (regIsFlash.test(keyword)){
				return "Tracking : Flash";
			}
			if (regIsJT.test(keyword)){
				return "Tracking : J&T";
			}
			if (regIsSPX.test(keyword)){
				return "Tracking : SPX";
			}

			//  check is tracking a-zA-Z  =>     EJ133238776TH   KELB013620312


			return  keyword=="" ? "" : "ชื่อผู้สั่งซื้อ"
		},
		keywordTypeID(){
			let keyword = this.params.order_number

			// check is mobile number , number[10] , start with 0
			var regIsMobileNumber = /^[0]\d{9}$/g;
			var regIsOrderMdfNumber = /MDF\d{1,12}$/gi;
			var regIsOrderNumber = /^\d{1,12}$/g;
			var regIsThaipost = /^[A-Z]{2}\d{9}[A-Z]{2}$/gi;
			var regIsKerry = /^[A-Z]{4}\d{9}$/gi;
			var regIsKerryLazada = /^[A-Z]{5}\d{10}$/gi;
			var regIsKerryShopee = /^SD[A-Z]{2}\d{10}$/gi;
			var regIsDHL = /^[A-Z]{5}\d{10}$/gi;
			var regIsFlash = /^TH[0-9A-Z]{12,13}$/gi;
			var regIsJT = /^[0-9]{12}$/gi;
			var regIsSPX = /^SPX[0-9A-Z]{12,14}$/gi;

			console.log("Keyword:",keyword)

			// #122: only true marketplaces (not all=0 / MDF=1 / MDFStore=9)
			// force the keyword to be treated as a tracking number.
			if (this.params.bo_platform_id != 0 && this.params.bo_platform_id != 1 && this.params.bo_platform_id != 9 )
			{
				return 3;
			}

			if(regIsMobileNumber.test(keyword)){
				return 1;
			}

			// check is order id  ,  start with mdf , number only
			if(regIsOrderMdfNumber.test(keyword)){
				return 2;
			}

			if(regIsOrderNumber.test(keyword)){
				return 2;
			}

			if(regIsThaipost.test(keyword)){
				return 3;
			}

			if(regIsKerry.test(keyword)){
				return 3;
			}

			if(regIsKerryLazada.test(keyword)){
				return 3;
			}

			if (regIsKerryShopee.test(keyword) || regIsDHL.test(keyword) || regIsFlash.test(keyword) || regIsJT.test(keyword) || regIsSPX.test(keyword)){
				return 3;
			}

			//  check is tracking a-zA-Z  =>     EJ133238776TH   KELB013620312


			return  keyword=="" ? 0 : 4
		},
		showForceFilterDate:function(){

			// Disable force filter date
			return false


			// let show = false

			// if (this.isSearchBasic)
			// 	return show

			// if (this.params.recipient_name != "") {
			// 	show = true
			// }
			// if (this.params.recipient_phone != "") {
			// 	show = true
			// }
			// if (this.params.tracking_number != "") {
			// 	show = true
			// }
			// if (this.params.order_number != "") {
			// 	show = true
			// }
			// return show

		},
		IsCod: function() {

			let iscod = false
			let payment_method = this.PaymentMethodTable.filter(v=>{
				return v.id == this.orderDetail.bo_payment_method_id
			})

			if (payment_method.length > 0){
				iscod = payment_method[0].type == 2
			}
			return iscod
		},

		// The list lives in utils/orderCancelReason.js so /seller/orders reuses it
		// (spec 2026-10-16 seller-order-cancel-actor-reason §5). Same ids + labels.
		CancelReasonTable: function() {
            return BO_CANCEL_REASONS;
        },
		PackingStatusTable:function(){
			return [
                { id: 0, name: "-- สถานะแพ็ค --" },
                { id: 1, name: "ปิดรายการสั่งซื้อ" },
                { id: 2, name: "ไม่ได้ปิดรายการสั่งซื้อ" },
                { id: 3, name: "รอแพ็ค" },
			]
		},
        OptionUserTable: function() {
            // return UserTable with all
            var data = this.UserTable;
			return [{ UserID: 0, fname: "-- พนักงาน --",lname:"" }, ...data]
            // data.unshift();
            // return data;
        },
        OptionTeamTable: function() {
            // return TeamTable with all
            var data = this.TeamTable;
            return [{ id: 0, name: "-- ทีม --" }, ...data];
        },
		DetailImage:	function(){
			if (this.Detail.payment_files == null || this.Detail.payment_files=="") return "";
			return process.env.VUE_APP_API_BASE_URL + "/files/orders/" + this.Detail.payment_files

		},
		isSearchBasic(){

			return this.searchMode == "basic"

		},
		isSearchAdvance(){
			return this.searchMode == "advance"
		},
		// return_source enum options for the return-in-transit filter.
		ReturnSourceTable(){
			return [
				{ id: "", name: "-- " + this.$t("return_source") + " --" },
				{ id: "spx", name: this.$t("return_source_spx") },
				{ id: "thaipost", name: this.$t("return_source_thaipost") },
				{ id: "lazada", name: this.$t("return_source_lazada") },
				{ id: "manual", name: this.$t("return_source_manual") },
				{ id: "unknown", name: this.$t("return_source_unknown") },
			];
		},

		SearchParams : function(){

			let keyword = this.params.order_number
			let filter = 1
            let platform_order_status = ""
			if (this.showForceFilterDate){
				filter = this.params.force_filter_date ? 1:0
			}

			if ( this.params.bo_packing_id != 0  || this.keywordTypeID != 0 ) {
				filter = 0
			}

			let order_status = []
			switch (this.params.order_status){
				case 0:

				break;

				case 999:
					order_status = [115,121,122,130]
				break;
                case 998:
                    order_status = [115,121,122]
                    platform_order_status = "CANCELLED"
                break;

				default:
					order_status = [this.params.order_status]
				break;
			}

            console.log("order_status",order_status)


			if (this.isSearchBasic) {

				return {
					time_from: this.params.time_to,
					time_to: this.params.time_to,
					order_status:order_status ,
					order_number: this.keywordTypeID == 2 ? this.params.order_number.toUpperCase().replace("MDF","") : "",
					tracking_number: this.keywordTypeID == 3 ? keyword : "",
					recipient_name: this.keywordTypeID == 4 ? keyword:"",
					recipient_phone: this.keywordTypeID == 1 ? keyword : "",
					bo_user_id: this.params.bo_user_id,
					bo_team_id: "",
					bo_customer_id: "",
					bo_sale_channel_id: "",
					bo_sale_channel_type_id: 0,
					bo_payment_status: this.params.bo_payment_status,
					bo_packing_id: this.params.bo_packing_id,
					shipping_provider_id: "",
					bo_platform_id: this.params.bo_platform_id,
					payment_method_type: "",
					filter_date: filter,
					packing_not_close:0,
                    platform_order_status: platform_order_status,
				}

			}

			return {
				time_from: this.params.time_from,
                time_to: this.params.time_to,
				order_status:order_status ,
                order_number: this.keywordTypeID == 2 ? this.params.order_number.toUpperCase().replace("MDF","") : "",
				tracking_number: this.keywordTypeID == 3 ? keyword : "",
				recipient_name: this.keywordTypeID == 4 ? keyword:"",
				recipient_phone: this.keywordTypeID == 1 ? keyword : "",
                bo_user_id: this.params.bo_user_id,
                bo_team_id: this.params.bo_team_id,
                bo_payment_method_id: this.params.bo_payment_method_id,
                bo_customer_id: this.params.bo_customer_id,
                bo_sale_channel_id: this.params.bo_sale_channel_id,
                bo_sale_channel_type_id: this.params.bo_sale_channel_type_id,
                bo_payment_status: this.params.bo_payment_status,
                bo_packing_status: this.params.bo_packing_status,
                bo_packing_id: this.params.bo_packing_id,
                shipping_provider_id: this.params.shipping_provider_id,
                bo_platform_id: this.params.bo_platform_id,
				payment_method_type: this.params.payment_method_type,
				filter_date: filter,
				packing_not_close: this.params.packing_not_close,
                platform_order_status: platform_order_status,
			}
		},

    },
    data() {
        return {
            // Overrides clientPaginationMixin's { perPage: 15, ... } for this
            // page only (component data wins over mixin data); the mixin is
            // shared by ~79 views and stays untouched. Spec P1/P3: 10 rows,
            // or the size remembered from the last visit.
            pagination: {
                perPage: readPageSize(pageSizeStorage(), ORDERS_PAGE_SIZE_KEY, 10),
                currentPage: 1,
                perPageOptions: PAGE_SIZES,
                total: 0
            },
            pageSizes: PAGE_SIZES,
            propsToSearch: ["OrderNmber", "TrackingNumber"],
            selectedRows: [],
            showAddModal: false,
            showDetailModal: false,
			showCancelModal  : false,
			showChangeTrackingModal : false,
			showChangeShippingModal : false,
			// Video download data (for return video)
			videoDownloadData: null,
			isLoadingVideo: false,
			// Shipping video download data
			shippingVideoDownloadData: null,
			isLoadingShippingVideo: false,
			searchMode : "basic", // basic , advance
			isClearingTracking: false,
			// mirakl Dev-B2: shared busy flag for Makro sync/accept/ship actions.
			miraklBusy: false,
			// 'all' = generic order list, 'return' = return-in-transit (143) queue.
			activeTab: "all",
			// Server-paginated filter state for the return-in-transit tab.
			returnParams: {
				time_from: "",
				time_to: "",
				bo_platform_id: 0,
				bo_sale_channel_id: 0,
				return_source: "",
				page: 1,
				per_page: 50,
			},
            // Same shape as before; the reset below reuses it (src/utils/sidebarReset.js).
            params: defaultOrderListParams(),
			params_cancel : {
				bo_cancel_reason_id : 0,
				cancel_reason : "",
				order_claim_to_id : "",
				images:[]
			},
            orderDetail: {
                ID: ""
            },
            // Tracking timeline payload from GET /api/v1/orders/:id/tracking-timeline.
            // null when the detail modal is closed or before the fetch returns.
            trackingTimeline: null,
            // Default-collapsed so a long history doesn't push the rest
            // of the detail modal below the fold.
            trackingTimelineExpanded: false,
			// PlatformTable: [
			// 		{id:1,name:"madamefin"},
			// 	{id:2,name:"tiktok"},
			// 	{id:3,name:"shopee"},
			// 	{id:4,name:"lazada"},
			// 	{id:5,name:"line"},
			// ],
			tracking:"",
			shipping_provider_id:1,
			isExportLoading: false,

        };
    },
    created() {
		// Not in data(): bookkeeping for activated(), never rendered.
		this.activatedOnce = false;
		// This instance's keep-alive key (DashboardLayout viewKey) and whether it
		// is on screen; the sidebar-reset watcher acts only while it is.
		this.ownTaskbarKey = taskbarKey(this.$route);
		this.isOnScreen = false;
    },
    async mounted() {

		console.log("param",this.$route.params)
		// moment today with format YYYY-MM-DD
		this.params.time_from = moment().add(-2, 'days').format('YYYY-MM-DD');
		this.params.time_to = moment().format('YYYY-MM-DD');
		// A new instance already starts from the defaults; drop the sidebar flag
		// that may have opened it so it cannot reset this tab later.
		consumeSidebarReset(this.ownTaskbarKey);

		// params.detail (post-create redirect) / params.bo_packing_id (packing
		// round); also consumes a pending requestRefresh so it cannot fire later.
		this.applyArrival(arrivalIntent(this.$route));

		if (this.$route.query.platform != undefined) {
			this.params.bo_platform_id = this.GetPlatfromID(this.$route.query.platform)
			this.searchMode = "advance"
		}



		this.listPaymentMethod()
        this.listUser();
        this.listTeam();
		this.listStorage();
		this.listData(this.SearchParams);
        await this.listSaleChannel();

		// if param
    },
    // Kept alive per taskbar tab (DashboardLayout.vue): a plain tab switch does
    // not refetch (R1); an arrival with intent — requestRefresh from the order
    // forms, or params.detail / params.bo_packing_id — does (R2/R3).
    // docs/specs/2026-10-07-bo-orders-refresh-on-arrival-design.md §4.2
    //
    // A sidebar click (src/utils/sidebarReset.js) starts over: the packing round
    // and every filter go back to the defaults, then any intent on the same
    // arrival is applied on top. A taskbar-tab click sets no flag (R1 holds).
    activated() {
		this.isOnScreen = true;
		if (!this.activatedOnce) { this.activatedOnce = true; return; } // first one: mounted() handled it (R4)
		const reset = consumeSidebarReset(this.ownTaskbarKey);
		if (reset) this.resetToPlainList();
		const intent = arrivalIntent(this.$route);
		if (!intent.refresh && !reset) return; // R1
		if (intent.refresh) this.applyArrival(intent);
		this.listData(this.SearchParams); // R2/R3
    },
    deactivated() {
		this.isOnScreen = false;
    },
    watch: {
		// Sidebar click while this tab is already on screen: the push is a
		// duplicate, nothing re-activates, so the flag is picked up here. While
		// the tab is off screen activated() consumes it instead.
		sidebarResetPending(pending) {
			if (!pending || !this.isOnScreen) return;
			if (!consumeSidebarReset(this.ownTaskbarKey)) return;
			this.resetToPlainList();
			this.listData(this.SearchParams);
		},
    },
    methods: {
		// Shopee cancel reconcile §11 F1: badges after the status.
		statusExtras(row) {
			return orderStatusExtras(row);
		},
		// P2/P4: client-side only -- back to page 1 and remember the size.
		// No router call here: /backoffice/orders is query-keyed in the taskbar,
		// so touching the query would open a new tab (and scroll).
		onPageSizeChange(size) {
			const n = normalizeSize(size);
			this.pagination.perPage = n;
			this.pagination.currentPage = 1;
			writePageSize(pageSizeStorage(), ORDERS_PAGE_SIZE_KEY, n);
		},
		// Back to the page a fresh visit shows: no packing round, default filters,
		// basic search, page 1. Owner 2026-10-16 (sidebar รายการสั่งซื้อ).
		resetToPlainList() {
			this.params = defaultOrderListParams(
				moment().add(-2, 'days').format('YYYY-MM-DD'),
				moment().format('YYYY-MM-DD')
			);
			this.searchMode = "basic";
			this.activeTab = "all";
			this.selectedRows = [];
			this.pagination.currentPage = 1;
		},
		applyArrival(intent) {
			if (intent.detail != null) {
				console.log("detail", intent.detail)
				this.handleDetail(intent.detail)
			}
			if (intent.boPackingId != null) {
				this.params.bo_packing_id = intent.boPackingId;
			}
			// OrdersNew.vue ⋮ menu hand-off (2026-10-07 status-tabs design §12.3)
			const ra = rowActionFromRoute(this.$route);
			if (ra && rowActionAllowed(ra.kind, ra.row, { isAdmin: this.isAdmin, isOwner: this.isOwner, isEmployee: this.isEmployee,
					isAccessPayment: this.isAccessPayment, isAgent: this.isAgent })) {
				if (ra.kind === "shipping") this.handleChangeShipping(ra.row);
				else if (ra.kind === "tracking") this.handleChangeTracking(ra.row);
				else this.handleDelete(null, ra.row);
			}
		},
        ...mapActions({
            createData: "Order/createData",
            updateData: "Order/updateData",
			cancelData: "Order/cancelData",
			changeTrackingOrder: "Order/changeTrackingOrder",
			changeShippingOrder: "Order/changeShippingOrder",
			checkTrackingOrder: "Order/checkTrackingOrder",
            listData: "Order/listData",
            listReturnInTransit: "Order/listReturnInTransit",
            listDataDetailProduct: "Order/listDataDetailProduct",
            listDatum: "Order/listDatum",
            listUser: "User/listData",
            listOrderDetail: "Order/getData",
            listTeam: "Team/listData",
            listSaleChannel: "SaleChannel/listData",
			listPaymentMethod: "PaymentMethod/listData",
			listStorage: "WmsStorage/listData",
			getShippingDocument: "Packing/getShippingDocument",
			getShippingDocumentV2: "Packing/getShippingDocumentV2",
			clearFailTracking: "Packing/ClearFailTracking",

        }),
		GetPlatfromID(platform) {
			let platform_id = 0
			this.PlatformTable.forEach(v=>{
					console.log(v.name)
				if (v.name.toLowerCase() == platform.toLowerCase())
				{
					platform_id = v.id
				}
			})

			return platform_id == 0 ? 1 : platform_id
		},
		GetClaimImage: function(filename) {
			if (filename == null || filename=="") return "";
			return process.env.VUE_APP_API_BASE_URL + "/files/orders/" + filename
		},
		GetCancelReasonName(id)
		{
			let result = this.CancelReasonTable.find(x => x.ID === id);
			return result != null ? result.Name : "-";
		},
        GetSaleChannelName: function(id) {

            var result = this.SaleChannelTable.find(x => x.id === id);
            return result != null ? result.name : "-";
        },
		GetStorageName: function(id) {
            var result = this.StorageTable.find(x => x.ID === id);
            return result != null ? result.Name : "-";
        },
		GetWmsProductSummary(){
			if (this.orderDetail.wms_product_summary == null) return [];
			let summary = JSON.parse(this.orderDetail.wms_product_summary);
			if (summary != null) {
				return summary;
			} else {
				return [];
			}
		},
        GetOrderStatus(id) {
            var data = this.OrderStatusTable;
            var result = data.find(x => x.ID === id);
            return result != null ? result.Name : "-";
        },
        handleSearch() {
            this.listData(this.SearchParams);
        },
        // --- Return-in-transit (status 143) tab ---
        switchTab(tab) {
            this.activeTab = tab;
            if (tab === "return") {
                this.returnParams.page = 1;
                this.loadReturnInTransit();
            }
        },
        loadReturnInTransit() {
            this.listReturnInTransit({
                time_from: this.returnParams.time_from,
                time_to: this.returnParams.time_to,
                bo_platform_id: this.returnParams.bo_platform_id,
                bo_sale_channel_id: this.returnParams.bo_sale_channel_id,
                return_source: this.returnParams.return_source,
                page: this.returnParams.page,
                per_page: this.returnParams.per_page,
            });
        },
        handleSearchReturn() {
            this.returnParams.page = 1;
            this.loadReturnInTransit();
        },
        handleReturnPageChange(page) {
            this.returnParams.page = page;
            this.loadReturnInTransit();
        },
        // Days since the parcel started returning; null when no timestamp.
        returnAgeDays(startedAt) {
            if (!startedAt) return null;
            const start = moment(startedAt);
            if (!start.isValid()) return null;
            return moment().startOf("day").diff(start.startOf("day"), "days");
        },
        ReturnSourceLabel(source) {
            const found = this.ReturnSourceTable.find(x => x.id === source);
            if (found && found.id !== "") return found.name;
            return this.$t("return_source_unknown");
        },
        GetPlatformName(id) {
            // #189: MDFStore order = platform_id 9 (BE persists a dedicated
            // platform enum for storefront orders synced into Backoffice).
            if (id === 9) {
                return this.$t("platform_mdfstore");
            }
            const found = this.PlatformTable.find(x => x.id === id);
            return found != null ? found.name : "-";
        },
        // --- #189 จำลอง (staging) simulate-fulfillment, MDFStore orders only ---
        // Buttons render only when the BE marked the row simulate_enabled
        // (config flag on + MDFStore) and the status is still inside the
        // fulfillment line; the BE re-validates everything server-side.
        canSimulate(status) {
            return [111, 112, 114, 115, 121, 122].includes(status);
        },
        simulateActionLabel(action) {
            if (action === "delivered") return this.$t("sim_delivered");
            if (action === "failed") return this.$t("sim_failed");
            return this.$t("sim_returned");
        },
        handleSimulate(row, action) {
            swal.fire({
                title: this.$t("sim_confirm_title"),
                text: this.simulateActionLabel(action) + " — #" + row.ID,
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("yes"),
                cancelButtonText: this.$t("no"),
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    OrderService.SimulateFulfillment(row.ID, action)
                        .then(() => {
                            swal.fire({
                                title: this.$t("sim_success"),
                                text: this.simulateActionLabel(action),
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                            this.handleSearch();
                        })
                        .catch(err => {
                            const data = err && err.response && err.response.data;
                            swal.fire({
                                title: "Error",
                                text: (data && (data.Msg || data.Message)) || String(err),
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });
                }
            });
        },
        copyTracking(value) {
            if (!value) return;
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(value);
            }
        },
        // Fetch the carrier-event timeline for this order and stash it
        // so the detail modal can render it. Failures are swallowed —
        // a missing timeline just hides the section.
        async loadTrackingTimeline(orderId) {
            this.trackingTimeline = null;
            // Reset to collapsed every time we open a different order so
            // an expanded state from a previous view doesn't carry over.
            this.trackingTimelineExpanded = false;
            try {
                const resp = await OrderService.OrderTrackingTimeline(orderId);
                const datum = resp && resp.data && resp.data.Datum;
                if (datum) {
                    this.trackingTimeline = datum;
                }
            } catch (err) {
                console.log("loadTrackingTimeline error", err);
            }
        },
        // Thaipost / SPX timeline events carry a `detail` field with the
        // full carrier payload (status_detail, office_name, office_tel,
        // location, ...). The helpers (#432: moved to @/utils/trackingTimeline,
        // shared with OrdersNew.vue) pull display-friendly fields out of it
        // without forcing the template to null-check each one.
        timelineStatusLine(ev) {
            return trackingTimelineUtil.timelineStatusLine(ev);
        },
        timelineLocation(ev) {
            return trackingTimelineUtil.timelineLocation(ev);
        },
        timelineOffice(ev) {
            return trackingTimelineUtil.timelineOffice(ev);
        },
        timelineOfficeTel(ev) {
            return trackingTimelineUtil.timelineOfficeTel(ev);
        },
        // Unix-seconds (event ts) or RFC3339 (last_updated_at) → "YYYY-MM-DD HH:mm".
        formatTimelineTs(value) {
            return trackingTimelineUtil.formatTimelineTs(value);
        },
        async handleDetail(row) {
            this.showDetailModal = true;
            this.orderDetail = row;
			console.log(this.orderDetail)
            this.listDatum({ id: row.ID });
            this.loadTrackingTimeline(row.ID);

            // Check if order is returned (status = 141) and fetch return video
            if (row.order_status === 141) {
                await this.fetchReturnVideo(row.ID, row.shipping_tracking_number);
            } else {
                // Clear return video data for non-returned orders
                this.videoDownloadData = null;
            }

            // Check if order is InTransit (121) or Complete (130) and fetch shipping video
            if (row.order_status === 115 || row.order_status === 121 || row.order_status === 130 || row.order_status === 122 || row.order_status === 140 || row.order_status === 143) {
                await this.fetchShippingVideo(row.ID, row.shipping_tracking_number);
            } else {
                // Clear shipping video data for other statuses
                this.shippingVideoDownloadData = null;
            }
        },
        
        // Fetch return video for returned orders
        async fetchReturnVideo(orderId, trackingNumber) {
            this.isLoadingVideo = true;
            this.videoDownloadData = null;

            try {
                const response = await OrderService.ReturnVideo({
                    order_id: orderId,
                    tracking_number: trackingNumber
                });

                if (response.data.status === 'success') {
                    this.videoDownloadData = response.data.data;
                    console.log('Return video data:', this.videoDownloadData);
                } else {
                    console.log('No return video found for this order');
                    this.videoDownloadData = null;
                }
            } catch (error) {
                console.error('Error fetching return video:', error);
                this.videoDownloadData = null;
            } finally {
                this.isLoadingVideo = false;
            }
        },

        // Fetch shipping video for InTransit/Complete orders
        async fetchShippingVideo(orderId, trackingNumber) {
            this.isLoadingShippingVideo = true;
            this.shippingVideoDownloadData = null;

            try {
                const response = await OrderService.ShippingVideo({
                    order_id: orderId,
                    tracking_number: trackingNumber
                });

                if (response.data.status === 'success') {
                    this.shippingVideoDownloadData = response.data.data;
                    console.log('Shipping video data:', this.shippingVideoDownloadData);
                } else {
                    console.log('No shipping video found for this order');
                    this.shippingVideoDownloadData = null;
                }
            } catch (error) {
                console.error('Error fetching shipping video:', error);
                this.shippingVideoDownloadData = null;
            } finally {
                this.isLoadingShippingVideo = false;
            }
        },
        
        // View return video file in new window
        viewVideo() {
            if (this.videoDownloadData && this.videoDownloadData.file_exists) {
                window.open(this.videoDownloadData.download_url, '_blank');
            }
        },

        // Download return video file
        async downloadVideo() {
            if (this.videoDownloadData && this.videoDownloadData.file_exists) {
                try {
                    const response = await fetch(this.videoDownloadData.download_url);
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = `RETURN_${this.orderDetail.ID}_${this.orderDetail.shipping_tracking_number}.webm`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);

                    // Show success alert
                    swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Return video downloaded successfully!',
                        showConfirmButton: false,
                        timer: 2000
                    });
                } catch (error) {
                    console.error('Error downloading return video:', error);

                    // Show error alert
                    swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to download return video. Please try again.',
                        showConfirmButton: true
                    });
                }
            }
        },

        // View shipping video file in new window
        viewShippingVideo() {
            if (this.shippingVideoDownloadData && this.shippingVideoDownloadData.file_exists) {
                window.open(this.shippingVideoDownloadData.download_url, '_blank');
            }
        },

        // Download shipping video file
        async downloadShippingVideo() {
            if (this.shippingVideoDownloadData && this.shippingVideoDownloadData.file_exists) {
                try {
                    const response = await fetch(this.shippingVideoDownloadData.download_url);
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = `SHIPPING_${this.orderDetail.ID}_${this.orderDetail.shipping_tracking_number}.webm`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);

                    // Show success alert
                    swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Shipping video downloaded successfully!',
                        showConfirmButton: false,
                        timer: 2000
                    });
                } catch (error) {
                    console.error('Error downloading shipping video:', error);

                    // Show error alert
                    swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to download shipping video. Please try again.',
                        showConfirmButton: true
                    });
                }
            }
        },
        
		handleExport(){

			let i = 1
			let dataExport = this.tableData.map((v) => {
				return {
				NO: i++,
				OrderID: v.ID,
				OrderStatus: this.GetOrderStatus(v.order_status),
				OrderAmount: v.pay_amount,
				OrderDiscount: v.discount,
				PaymentMethod: v.bo_payment_method_name,
				CreatedAt: v.created_at,
				PaymentAt: v.payment_at,
				SaleChannel : this.GetSaleChannelName(v.bo_sale_channel_id),
				Receipent : v.recipient_name,
				RECEIVER_ADDRESS: v.recipient_address_fulladdress,
				RECEIVER_AMPHUR: v.recipient_address_city,
				RECEIVER_PROVINCE: v.recipient_address_province,
				RECEIVER_ZIPCODE: v.recipient_zipcode,
				RECEIVER_TEL: v.recipient_phone,
				Shipping: v.shipping_provider_name,
				Tracking: v.shipping_tracking_number,
				AdminID: v.bo_order_user_id,
				AdminName: v.bo_order_user_name,
				}

			})
			const dataWS = utils.json_to_sheet(dataExport)
			const wb = utils.book_new()
			utils.book_append_sheet(wb, dataWS)
			writeFile(wb,'export_orders.xlsx')
		},
		async handleExportDetail(){

			this.isExportLoading = true
			swal.fire({
				title: this.$t(`processing`),
				type: "info",
				allowEscapeKey: false,
				allowOutsideClick: false,
				onOpen: () => {
					swal.showLoading();
				}
			  });


			let poll = async () => {
				try {
					let i = 1
					let res = await this.listDataDetailProduct(this.SearchParams)
					console.log("res",res)

					if (res.data.Datum.state == 1 ){
						if (res.data.Datum.orders.length == 0){
							swal.fire({
								title: "Export error",
								text: `ไม่พบข้อมูล`,
								icon: "error",
								confirmButtonClass: "btn btn-danger btn-fill",
								buttonsStyling: false
							});
							this.isExportLoading = false
							return
						}
						swal.close()
						this.isExportLoading = false
						console.log("Get response ok",res)
						let dataExport = res.data.Datum.orders.map((v) => {
							return {
							NO: i++,
							OrderID: v.ID,
							OrderStatus: this.GetOrderStatus(v.order_status),
							OrderAmount: v.pay_amount,
							OrderDiscount: v.discount,
							PaymentMethod: v.bo_payment_method_name,
							CreatedAt: v.created_at,
							PaymentAt: v.payment_at,
							SaleChannel : this.GetSaleChannelName(v.bo_sale_channel_id),
							Receipent : v.recipient_name,
							RECEIVER_ADDRESS: v.recipient_address_fulladdress,
							RECEIVER_AMPHUR: v.recipient_address_city,
							RECEIVER_PROVINCE: v.recipient_address_province,
							RECEIVER_ZIPCODE: v.recipient_zipcode,
							RECEIVER_TEL: v.recipient_phone,
							Shipping: v.shipping_provider_name,
							Tracking: v.shipping_tracking_number,
							AdminID: v.bo_order_user_id,
							AdminName: v.bo_order_user_name,
							Product: v.orders_item_product_name,
							SKU: v.orders_item_product_sku_name,
							Quantity : v.orders_item_quantity,
							PricePerUnit: v.orders_item_price_per_unit,
							ProductAmount: (v.orders_item_quantity * v.orders_item_price_per_unit) - v.discount,
							}
						})
						const dataWS = utils.json_to_sheet(dataExport)
						const wb = utils.book_new()
						utils.book_append_sheet(wb, dataWS)
						writeFile(wb,'export_orders_detail.xlsx')
					} else if (res.data.Datum.state == 0){
						console.log("state 0")
						setTimeout(poll, 1000);
					} else {
						this.isExportLoading = false
						swal.fire({
							title: "Export error",
							text: `database failed`,
							icon: "error",
							confirmButtonClass: "btn btn-danger btn-fill",
							buttonsStyling: false
						});
					}
				} catch (err){
					console.log(err)
					this.isExportLoading = false
					swal.fire({
						title: "Export error",
						text: err,
						icon: "error",
						confirmButtonClass: "btn btn-danger btn-fill",
						buttonsStyling: false
					});
				}
			}


			poll();

		},

        handleCreate() {
            this.$router.push("/backoffice/orders/create");
        },
        handleUpdate() {
            // 	this.showAddModal = true;
            //   this.md.ID = 0
            //   this.md.Email = ""
            //   this.md.FName = ""
            //   this.md.LName = ""
            //   this.md.Type = ""
            //   this.md.FbID = ""
            //   this.md.IsBlock = ""
            //   this.md.Tel = ""
            //   this.md.BirthDay = ""
            //   this.md.CreatedAt = ""
            //   this.md.UpdatedAt = ""
        },
        handleEdit(index, row) {
            this.showAddModal = true;

            this.md.ID = row.ID;
            this.md.Email = row.Email;
            this.md.FName = row.FName;
            this.md.LName = row.LName;
            this.md.Type = row.Type;
            this.md.FbID = row.FbID;
            this.md.IsBlock = row.IsBlock;
            this.md.Tel = row.Tel;
            this.md.BirthDay = row.BirthDay;
            this.md.CreatedAt = row.CreatedAt;
            this.md.UpdatedAt = row.UpdatedAt;
        },
        async handleDelete(index, row) {
			this.showCancelModal  = true;
            this.orderDetail = row;
			this.params_cancel.cancel_reason = ""
			this.params_cancel.bo_cancel_reason_id = 0
			this.params_cancel.images = []
        },
		isAccessDeleleteOrder(orderStatus){
			// Cancel/return family (>= 140) hides the trash button for every role;
			// see src/utils/orderDelete.js.
			return canDeleteOrder({
				orderStatus,
				isAdmin: this.isAdmin,
				isOwner: this.isOwner,
				isEmployee: this.isEmployee,
				isAccessPayment: this.isAccessPayment,
				isAgent: this.isAgent,
			})
		},
		handelUpdateCancel(){

			if (this.params_cancel.bo_cancel_reason_id == 0) {
				swal.fire({
					title: this.$t("please_select_cancel_reason"),
					text: ``,
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}

			if (this.params_cancel.cancel_reason == "") {
				swal.fire({
					title: this.$t("please_input_cancel_reason"),
					text: ``,
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}

			this.cancelData({
                        id: this.orderDetail.ID,
						payload: this.params_cancel
                    })
                        .then(resp => {
							this.showCancelModal = false;
                            this.listData(this.SearchParams);
                            swal.fire({
                                title: this.$t("cancel_order_success"),
                                text: ``,
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                        })
                        .catch(err => {
                            swal.fire({
                                title: this.$t(err.response.data.Msg),
                                text: this.getErrorText(err.response.data),
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });

		},
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows;
        },
		GetOrderUrl(filename){
			if (filename == null || filename=="") return "";
			return process.env.VUE_APP_API_BASE_URL + "/files/orders/" + filename
		},
		claimFilesChange(files) {

			if (files[0].type != "image/png" && files[0].type != "image/jpeg") {
				swal.fire({
					title: "Error",
					text: "กรุณาเลือกไฟล์รูปภาพ",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
			}

			if (files[0].size > 1024 * 1024 *2 ) {
				swal.fire({
					title: "Error",
					text: "ขนาดไฟล์รูปภาพต้องไม่เกิน 2 MB",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}

			const reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = () => {
				// append to params cancel image array
				this.params_cancel.images.push(reader.result)
            };
        },
		handleChangeShipping(row){
			this.showChangeShippingModal = true
			this.orderDetail = row
			this.shipping_provider_id = row.shipping_provider_id
		},
		handleUpdateShipping(){
			this.changeShippingOrder({
                        id: this.orderDetail.ID,
						payload: {
							shipping_provider_id: this.shipping_provider_id
						}
                    }).then(resp => {
							this.showChangeShippingModal = false;
                            this.listData(this.SearchParams);
                            swal.fire({
                                title: this.$t("change_shipping_success"),
                                text: ``,
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                        })
                        .catch(err => {
							this.showChangeTrackingModal = false
                            swal.fire({
                                title: this.$t(err.response.data.Msg),
                                text: this.getErrorText(err.response.data),
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });

		},
		handleChangeTracking(row){
			this.showChangeTrackingModal = true
			this.orderDetail = row
			this.tracking = row.shipping_tracking_number

		},

		// #931: ChangeTrackingDialog saved — patch the row, keep the number for the Makro retry.
		onTrackingChanged({ id, tracking_number }){
			this.tracking = tracking_number
			if (this.orderDetail && Number(this.orderDetail.ID) === Number(id)) {
				this.orderDetail.shipping_tracking_number = tracking_number
			}
			this.listData(this.SearchParams);
		},
		handlePackingByID(){
			this.$router.push({name : "BOPacking", params : { bo_packing_id : this.orderDetail.bo_packing_id} })
		},
		// mirakl Dev-B2 — Makro (Mirakl) order actions. All user-triggered; the
		// buttons only render for platform_id === 10 orders. On success we refresh
		// the list so the Mirakl state / tracking columns reflect the change.
		handleMiraklSync(){
			this.miraklBusy = true
			OrderService.miraklSyncOrders({})
				.then(resp => {
					const d = (resp && resp.data && resp.data.Datum) ? resp.data.Datum : ((resp && resp.data) || {})
					this.listData(this.SearchParams)
					swal.fire({
						title: this.$t("makro_order.sync_started"),
						text: d.job_id ? ("Job #" + d.job_id) : "",
						icon: "success",
						confirmButtonClass: "btn btn-success btn-fill",
						buttonsStyling: false
					})
				})
				.catch(err => {
					// 422 = a Makro sync is already in flight; surface its job id, not an error.
					if (err.response && err.response.status === 422 && err.response.data && err.response.data.job_id) {
						swal.fire({
							title: this.$t("makro_order.sync_running"),
							text: "Job #" + err.response.data.job_id,
							icon: "info",
							confirmButtonClass: "btn btn-info btn-fill",
							buttonsStyling: false
						})
						return
					}
					this.miraklSwalError(err)
				})
				.finally(() => { this.miraklBusy = false })
		},
		handleMiraklAccept(){
			this.miraklBusy = true
			OrderService.miraklAcceptOrder(this.orderDetail.ID)
				.then(() => {
					this.showDetailModal = false
					this.listData(this.SearchParams)
					swal.fire({
						title: this.$t("makro_order.accept_success"),
						text: "",
						icon: "success",
						confirmButtonClass: "btn btn-success btn-fill",
						buttonsStyling: false
					})
				})
				.catch(err => { this.miraklSwalError(err) })
				.finally(() => { this.miraklBusy = false })
		},
		handleMiraklShip(){
			if (!this.tracking) {
				swal.fire({
					title: this.$t("makro_order.tracking_required"),
					text: "",
					icon: "warning",
					confirmButtonClass: "btn btn-warning btn-fill",
					buttonsStyling: false
				})
				return
			}
			this.miraklBusy = true
			OrderService.miraklShipOrder(this.orderDetail.ID, {
					tracking_number: this.tracking,
					carrier_name: this.orderDetail.shipping_provider_name || ""
				})
				.then(() => {
					this.showChangeTrackingModal = false
					this.listData(this.SearchParams)
					swal.fire({
						title: this.$t("makro_order.ship_success"),
						text: "",
						icon: "success",
						confirmButtonClass: "btn btn-success btn-fill",
						buttonsStyling: false
					})
				})
				.catch(err => { this.miraklSwalError(err) })
				.finally(() => { this.miraklBusy = false })
		},
		miraklSwalError(err){
			const data = (err && err.response && err.response.data) || {}
			swal.fire({
				title: data.Msg ? this.$t(data.Msg) : this.$t("makro_order.action_failed"),
				text: this.getErrorText ? this.getErrorText(data) : (data.Cause || ""),
				icon: "error",
				confirmButtonClass: "btn btn-danger btn-fill",
				buttonsStyling: false
			})
		},
		async handlePrintDocument(pagesize){
			this.getShippingDocumentV2({order_id:this.orderDetail.ID,pageSize:pagesize,force_create:1}).then(resp => {
				// url = api path
				let url = process.env.VUE_APP_API_BASE_URL + "/files/packings/" + resp.data.Datum.url
				window.open(url, '_blank');
			}).catch(err => {
				swal.fire({
					title: err.response.data.Cause,
					text: "",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
			});
		},
		async handleCheckTracking(providerId,trackingNumber){


			if (providerId == 1 ) {
				let url = "https://track.thailandpost.co.th/?trackNumber=" + trackingNumber
				try {
					await navigator.clipboard.writeText(url)
				} catch (err){
					console.log(err)
				}
				// window.open(url)
			} else if (providerId == 2 ) {
				let url = "https://th.kerryexpress.com/th/track/"
				try {
					await navigator.clipboard.writeText(url)
				} catch (err){
					console.log(err)
				}
				// window.open(url)

			}

		},

		async handleClearNoTracking() {
			if (!this.params.bo_packing_id) {
				swal.fire({
					title: "Error",
					text: "No packing ID found",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}

			try {
				const result = await swal.fire({
					title: "Confirm Clear No Tracking",
					text: "Are you sure you want to clear the no tracking status?",
					icon: "warning",
					showCancelButton: true,
					confirmButtonClass: "btn btn-success btn-fill",
					cancelButtonClass: "btn btn-danger btn-fill",
					confirmButtonText: "Confirm",
					cancelButtonText: "Cancel",
					buttonsStyling: false
				});

                console.log("result",result)

				if (result) {
					this.isClearingTracking = true;
					const response = await this.clearFailTracking(this.params.bo_packing_id);

					const updatedCount = response.data.Datum.updated_count || 0;

					swal.fire({
						title: "Success",
						text: `No tracking status cleared successfully. Updated ${updatedCount} record(s).`,
						icon: "success",
						confirmButtonClass: "btn btn-success btn-fill",
						buttonsStyling: false
					}).then(() => {
                        // Close the modal if needed
                        this.showChangeTrackingModal = false;
                        // Refresh the data to get updated information
                        this.handleSearch();
                    });

				}
			} catch (error) {
				console.error('Error clearing no tracking:', error);
				swal.fire({
					title: "Error",
					text: "Failed to clear no tracking status",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
			} finally {
				this.isClearingTracking = false;
			}
		}
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
<style scoped>
/*
 * Main list cells (spec 2026-10-07-bo-orders-pagination-size §7 D1): 8px
 * instead of 16px side padding on every td/th of the main table, so each
 * column's room = min-width - 16. The table scrolls horizontally (sum of
 * min-widths > available width), so every column renders at exactly its
 * min-width; widths in the template were measured against that (§7 D2).
 *
 * The padding sits on the <td>/<th>, not on .cell: core/vendors/_element-tables.scss
 * puts $table-cell-padding (1rem) on `div.el-table tbody td, thead th` and
 * already zeroes `.cell`. Those nodes are rendered by el-table and carry no
 * scope attribute of this component -- hence ::v-deep, with the class set via
 * cell-class-name / header-cell-class-name on the main <el-table> only (the
 * return tab's table keeps 1rem). Compiled, the selector is
 * `[data-v-x] .el-table td.bo-orders-cell` (0,3,1), which outranks
 * `div.el-table tbody td` (0,1,3).
 */
::v-deep .el-table td.bo-orders-cell,
::v-deep .el-table th.bo-orders-cell {
    padding-left: 8px;
    padding-right: 8px;
}
</style>
